import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { Task } from "../mutation/useTaskCreateMutation";


export type TaskResponse = ResponseType<Task[]>;

function useAllTaskQuery(projectId:string|undefined, enabled = false) {
  return useQuery<
    AxiosResponseAndError<TaskResponse>["response"],
    AxiosResponseAndError<TaskResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.allTask, projectId],
    queryFn: async () =>
      await ApiRequest.get(requestURLs.task+projectId),
    enabled: enabled,
  });
}

export default useAllTaskQuery;
